import React from 'react';
import { colors, typography } from '../../../styles/theme';
import FilterRangeChips from './FilterRangeChips';

const wrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%',
};

const labelStyle = {
  fontSize: typography.fontSize.sm,
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.medium,
  color: colors.textPanelDescription,
};

const hintStyle = {
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  color: colors.textSecondary,
  lineHeight: 1.4,
  opacity: 0.75,
};

/**
 * Filtro por bandas fijas (menor a / rangos / mayor a).
 * Multi-selección OR — más claro y performante que un slider libre.
 *
 * @param {string} [hint] nota al pie; se usa para explicar por qué está deshabilitado
 * @param {number} [columns] columnas de la grilla; por defecto una fila única
 */
function FilterRangeBands({
  label,
  options,
  selectedValues = [],
  onChange,
  disabled = false,
  hint = null,
  columns = null,
}) {
  const isActive = selectedValues.length > 0;

  return (
    <div style={wrapStyle}>
      <span style={{ ...labelStyle, opacity: isActive ? 1 : 0.75 }}>{label}</span>
      <FilterRangeChips
        options={options}
        selectedValues={selectedValues}
        disabled={disabled}
        columns={columns}
        onChange={onChange}
      />
      {hint && <span style={hintStyle}>{hint}</span>}
    </div>
  );
}

export default FilterRangeBands;
